import { useState, useEffect } from 'react';
import { useMemo } from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'font-awesome/css/font-awesome.min.css';
import '../css/main.css';
import { faFolderOpen,faCalendar,faClock,faPause,faTriangleExclamation,faCalendarDay,faStopwatch,faComment,faUserPlus,faUserTie } from '@fortawesome/free-solid-svg-icons';

const TaskInfo = ({data}) => {
     const [formData, setFormData] = useState({});
  const [projectName, setProjectName] = useState('');
  const [comments, setComments] = useState([]);
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [newCommentText, setNewCommentText] = useState('');
  const [currentUser, setCurrentUser] = useState(null);

useEffect(() => {
  const fetchUserData = async () => {
    // Try admin first
    try {
      const adminRes = await axios.get('/api/login.php?action=dashboard', {
        withCredentials: true,
      });

      if (adminRes.data?.admin) {
        setCurrentUser(adminRes.data.admin);
        return;
      }
    } catch (err) {
      // Only log error if it's not 401
      if (err.response?.status !== 401) {
        console.error("Admin fetch failed:", err);
      }
    }

    // Fallback to user
    try {
      const userRes = await axios.get('/api/mainuser.php?action=dashboard', {
        withCredentials: true,
      });

      if (userRes.data?.user) {
        setCurrentUser(userRes.data.user);
        return;
      }
    } catch (err) {
      if (err.response?.status !== 401) {
        console.error("User fetch failed:", err);
      }
      window.location.href = '/login';
    }
  };

  fetchUserData();
}, []);






  useEffect(() => {
    fetch('/api/getusers.php')
      .then(res => res.json())
      
      .catch(err => console.error("Error loading users:", err));
  }, []);
  

const clampSessionToWorkingHours = (start, end) => {
     const WORK_INTERVALS = [
    { from: { h: 9, m: 30 }, to: { h: 13, m: 30 } },
    { from: { h: 14, m: 0 }, to: { h: 18, m: 0 } },
  ];
  let clamped = 0;
  let current = new Date(start);
  let latestEnd = null;

  while (current < end) {
    if (current.getDay() !== 0) { // skip Sunday
      for (const { from, to } of WORK_INTERVALS) {
        const intervalStart = new Date(current);
        intervalStart.setHours(from.h, from.m, 0, 0);

        const intervalEnd = new Date(current);
        intervalEnd.setHours(to.h, to.m, 0, 0);

        const actualStart = new Date(Math.max(start.getTime(), intervalStart.getTime()));
        const actualEnd = new Date(Math.min(end.getTime(), intervalEnd.getTime()));

        if (actualStart < actualEnd) {
          clamped += actualEnd - actualStart;
          if (!latestEnd || actualEnd > latestEnd) {
            latestEnd = actualEnd;
          }
        }
      }
    }

    current.setDate(current.getDate() + 1);
    current.setHours(0, 0, 0, 0);
  }

  return { clamped, latestEnd };
};
const sessionStats = useMemo(() => {
  const MAX_MS = 8 * 60 * 60 * 1000; // 8 hours

 

  try {
    const sessions = JSON.parse(formData.duration || '[]');
    const dateGroups = {};

    sessions.forEach(session => {
      if (!session.start) return;

      const start = new Date(session.start);
let end = session.end
  ? new Date(session.end)
  : session.pause
  ? new Date(session.pause)
  : new Date(); // ongoing

// Clamp end to same date as start (no carry to next day)
const sessionEndDate = end.toISOString().split('T')[0];
const sessionStartDate = start.toISOString().split('T')[0];
if (sessionEndDate !== sessionStartDate) {
  // Set end to 23:59:59 of start date
  end = new Date(start);
  end.setHours(23, 59, 59, 999);
}


      const { clamped, latestEnd } = clampSessionToWorkingHours(start, end);
      const sessionDate = start.toISOString().split('T')[0];

      if (!dateGroups[sessionDate]) {
  dateGroups[sessionDate] = {
    totalMs: 0,
    sessions: [],
    firstStart: start,
    lastEnd: latestEnd,
    readableDate: `${start.getDate().toString().padStart(2, '0')}/${
      (start.getMonth() + 1).toString().padStart(2, '0')
    }/${start.getFullYear()}`
  };
}

dateGroups[sessionDate].totalMs += clamped;
dateGroups[sessionDate].sessions.push({ start, end, duration: clamped });

if (start < dateGroups[sessionDate].firstStart) {
  dateGroups[sessionDate].firstStart = start;
}
if (latestEnd && latestEnd > dateGroups[sessionDate].lastEnd) {
  dateGroups[sessionDate].lastEnd = latestEnd;
}
    });

    const formatTime = (ms) => {
      const h = String(Math.floor(ms / (1000 * 60 * 60))).padStart(2, '0');
      const m = String(Math.floor((ms / (1000 * 60)) % 60)).padStart(2, '0');
      const s = String(Math.floor((ms / 1000) % 60)).padStart(2, '0');
      return `${h}:${m}:${s}`;
    };

    return Object.entries(dateGroups).map(([date, data]) => ({
  date: data.readableDate,
  startTime: data.firstStart.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }),
  endTime: data.lastEnd.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }),
  totalMs: data.totalMs,
  readableTime: formatTime(data.totalMs),
  percent: Math.min(100, (data.totalMs / MAX_MS) * 100),
}));
  } catch {
    return [];
  }
}, [formData.duration]);



  




  useEffect(() => {
    if (data?.project_id) {
      setFormData(data);
      fetch(`/api/projectname.php?method=getById&project_id=${data.project_id}`)
        .then(res => res.json())
        .then(response => {
          if (response.success && response.project) {
            setProjectName(response.project.name);
          } else {
            setProjectName('Project not found');
          }
        })
        .catch(error => {
          console.error('Failed to fetch project name:', error);
          setProjectName('Error fetching name');
        });
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);

  useEffect(() => {
  if (formData.task_id) {
    fetch(`/api/task_comments.php?task_id=${formData.task_id}`)
      .then(res => res.json())
      .then(data => {
        setComments(Array.isArray(data.comments) ? data.comments : []);
      })
      .catch(() => {
        setComments([]);
      });
  }
}, [formData.task_id]);


        



 




const handleAddComment = () => {
  if (!newCommentText.trim()) return;

  const now = new Date();
  const timestamp = now.toLocaleString(); // e.g., 7/16/2025, 10:45:23 AM
  const formattedComment = `${newCommentText.trim()} -- ${timestamp}, ${currentUser?.username || 'Unknown'}`;

  fetch(`/api/task_comments.php?task_id=${formData.task_id}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ newComment: formattedComment }),
  })
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data.comments)) {
        setComments(data.comments);
        setNewCommentText('');
        setShowCommentInput(false);
      } else {
        console.error("Invalid comment response");
      }
    })
    .catch(err => {
      console.error("Failed to save comment:", err);
    });
};





            let firstStartShown = false;
  return (
    <div className='border border-gray-200 p-2  bg-gray-50 h-full min-h-screen'>
         <div className="space-y-2">

            {/* Project ID */}
            <div className=' bg-white p-3 shadow-sm rounded-sm'>
                <p className='text-gray-700 text-xl rounded font-semibold'></p>
                <p className="block text-sm font-medium text-gray-700">
                  <span className="text-xl"><FontAwesomeIcon icon={faFolderOpen} className='text-yellow-400'/></span> <span className=''> {formData.project_id ? `${formData.project_id}:` : <span className='text-xl'>Single Task</span>}</span>  <span className=''>{projectName}</span>
                </p>
                <p className="block text-[12px] font-medium text-gray-700 border-l  ml-2 pt-2 pl-2"> - <span className=''>{formData.task_id || ''}: </span> {formData.task_name || ''} </p>
            </div>

            <div className='flex gap-2 mb-1'>
                {/* Status */}
                <div className='flex w-[49%] bg-white px-3 py-1 shadow-sm rounded-xs'>
                    <label className="block text-xs font-medium text-gray-700 p-1 pl-0"> <FontAwesomeIcon icon={faPause} className='text-sm mr-1 text-orange-400'/> Status: </label>
                    <div className="relative text-xs ">
                      <div
                        className="font-medium px-2 py-[1px] mt-1 ml-2 rounded-lg text-center cursor-pointer text-[10px]"
                        style={{
                          backgroundColor:
                            formData.status === "To Do"
                              ? "#fde68a"
                              : formData.status === "Doing"
                              ? "#bfdbfe"
                              : formData.status === "Done"
                              ? "#bbf7d0"
                              : formData.status === "Hold"
                              ? "#c2c2c2ff"
                              : "transparent",
                        }}
                      >
                        {formData.status || "Select Status"}
                      </div>
                    </div>
                </div>
                {/* Priority */}
                <div className='flex w-[49%] bg-white px-2 py-1 shadow-sm rounded-xs'>
                  <label className="block text-xs font-medium text-gray-700 p-1"><FontAwesomeIcon icon={faTriangleExclamation} className='text-sm text-red-500'/> Priority: </label>
                    <div className="relative text-xs mr-7">
                      <div
                        className="text-[10px]  px-2 py-[1px] mt-1 ml-2  rounded-lg text-center "
                        style={{
                          backgroundColor:
                            formData.priority === "Medium"
                              ? "#d1fae5"
                              : formData.priority === "Urgent"
                              ? "#f87171"
                              : "transparent",
                          color: formData.priority === "Urgent" ? "white" : "inherit",
                        }}
                      >
                        {formData.priority || "No Priority"}
                      </div>
                    </div>
                </div>
            </div>

            <div className='flex gap-2 mt-2 mb-1'>
              <div className='w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs'>
                <p className="block text-xs font-medium text-gray-700"><span className="text-xs"><FontAwesomeIcon icon={faCalendar} className='text-xs pb-[1px] mr-1 text-blue-400' /> Start Date:  </span> {formData.start_date ? new Date(formData.start_date).toLocaleDateString('en-GB') : <span className="mr-3">No Date</span>}</p>
              </div>
              <div className='w-[49%] bg-white px-3 py-2 shadow-sm rounded-xs'>
                <p className="block text-xs font-medium text-gray-700"><span className="text-xs"><FontAwesomeIcon icon={faClock} className='text-xs pb-[1px] mr-1 text-gray-400'/>Tentative Time:  </span> {formData.submission_date  || '0 '}hr</p>
              </div>
            </div>
            <div className='flex gap-2 mt-2 mb-1'>
              <div className='w-[49%] bg-white p-3  shadow-sm rounded-xs'>
                <p className="block text-xs font-medium text-gray-700 whitespace-nowrap">
                  <span className="text-xs">
                    <FontAwesomeIcon icon={faUserTie} className='text-xs pb-[1px] mr-2 text-lime-500' />Assign By:
                  </span>
                  <span
                    className='bg-gray-200 p-1 px-2 rounded-sm shadow-lg ml-2 text-[11px]'
                    title={formData.assign_by || 'Undefined'}
                  >
                    {(formData.assign_by?.split(" ")[0]) || 'Undefined'}
                  </span>
                </p>
              </div>
                <div className='w-[49%] bg-white p-3 shadow-sm rounded-xs'>
                  <p className="block text-xs font-medium text-gray-700 whitespace-nowrap">
                    <span className="text-xs">
                      <FontAwesomeIcon icon={faUserPlus} className='text-xs pb-[1px] mr-1 text-emerald-700' />Assign To:
                    </span>
                    <span
                      className='bg-gray-200 p-1 px-2 rounded-sm shadow-lg ml-2 text-[11px]'
                      title={formData.assign_to || 'Undefined'}
                    >
                      {(formData.assign_to?.split(" ")[0]) || 'Undefined'}
                    </span>
                  </p>
                </div>
              </div>
            <div className='text-gray-700 font-medium text-xs mt-2 bg-white p-3 shadow-sm rounded-xs'>
            <FontAwesomeIcon icon={faCalendarDay} className='text-xs mr-1 text-rose-400'/>  Submission Date: <span className='font-medium text-[11px]'>{formData.due_date ? new Date(formData.due_date).toLocaleDateString('en-GB') : <span className="mr-3">No Date</span>}</span>
            </div>

            <div className="w-full flex flex-col gap-2 mt-2 bg-white shadow-lg p-3">
                      <label className='text-sm text-gray-700 font-semibold ml-1'>Working Hour:</label>

  {sessionStats.map((entry, index) => {
    const allSessions = (() => {
      try {
        const parsed = JSON.parse(formData.duration || '[]');
        return parsed.filter(s => {
          if (!s.start) return false;
          const startDate = new Date(s.start).toISOString().split('T')[0];
          return startDate === entry.date.split("/").reverse().join("-"); // match dd/mm/yyyy
        });
      } catch {
        return [];
      }
    })();


    const formatDuration = (ms) => {
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}h ${minutes}m`;
};



    return (
      <div key={index} className=" bg-gray-50 p-2 shadow-sm rounded-xs">
        {/* Duration Bar */}

        {/* Date + Session Timing */}
        <div className='justify-between text-xs mb-1 flex'>
          <span className="text-gray-700 text-xs mt-1 mb-3 ">
            <FontAwesomeIcon icon={faCalendar} className='text-xs pb-[1px] mr-1 text-rose-400' /> Date:  {entry.date}  
          </span>
          <span className='font-semibold text-gray-700'><FontAwesomeIcon icon={faStopwatch} className='text-sm'/> {(() => {
              const [h, m] = entry.readableTime.split(':').map(Number);
              return `${h}h ${m}m`;
          })()}</span>
        </div>
        
        <div className='flex justify-center'>
            
            <div className="space-y-2 text-xs text-gray-700 font-mono border-dashed mt-3  ">
              {allSessions.length > 0 ? (
                allSessions.map((session, i) => (
                  <div
                    key={i}
                    className="p-1 rounded-md  flex justify-center"
                  >
                    {session.start && (() => {
                      const isFirstStart = !firstStartShown;
                      if (isFirstStart) firstStartShown = true;
                      return (
                        <p className={`${isFirstStart ? 'bg-green-200 text-green-700' : 'bg-blue-200 text-blue-700'} mr-2 font-semibold px-2 rounded-lg text-[10px]`}>
                          {new Date(session.start).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })}
                        </p>
                      );
                    })()}

                    {session.pause && (() => {
                      const startTime = new Date(session.start);
                      let endTime = new Date(session.pause);
                      const sameDayEnd = new Date(startTime);
                      sameDayEnd.setHours(18, 0, 0, 0); // Clamp to 6:00 PM
                    
                      if (endTime > sameDayEnd) endTime = sameDayEnd;
                    
                      return (
                        <>
                          <p className="text-[10px] text-yellow-500 font-mono ml-1 font-semibold">
                            ... ⏱ {formatDuration(clampSessionToWorkingHours(startTime, endTime).clamped)} ...
                          </p>
                          <p className='bg-yellow-200 ml-2 font-semibold text-yellow-700 px-2 rounded-lg text-[10px]'>
                            {endTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                          </p>
                        </>
                      );
                    })()}



                    {session.end && (() => {
                      const startTime = new Date(session.pause || session.start);
                      let endTime = new Date(session.end);
                      const sameDayEnd = new Date(startTime);
                      sameDayEnd.setHours(18, 0, 0, 0); // Clamp to 6:00 PM
                      if (endTime > sameDayEnd) endTime = sameDayEnd;
                      return (
                        <>
                          <p className="text-[10px] text-red-500 font-mono ml-1 font-semibold text-[10px]">
                            ... ⏱ {formatDuration(clampSessionToWorkingHours(startTime, endTime).clamped)} ...
                          </p>
                          <p className='bg-red-200 ml-3 font-semibold text-red-700 px-2 rounded-lg text-[10px]'>
                            {endTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                          </p>
                        </>
                      );
                    })()}


            </div>
            
            ))
          ) : (
            <p className="text-gray-400 text-xs italic">No sessions</p>
          )}
        </div>
        
      </div>
      
        {/* Start / Pause / End List for that date */}
      </div>
    );
  })}
</div>
          <div className='bg-white p-3 shadow-sm rounded-xs'>
            {/* Comment */}
            <div className=''>
              <label className="block text-xs font-medium text-gray-700 mb-1"><FontAwesomeIcon icon={faComment} className='text-xs mr-1 text-yellow-600'/>Comments</label>
              {comments.map((cmt, idx) => {
                // Split comment into text and metadata
                let commentText = cmt;
                let commentMeta = '';
                if (typeof cmt === 'string' && cmt.includes(' -- ')) {
                  const parts = cmt.split(' -- ');
                  commentText = parts[0];
                  commentMeta = '-- ' + parts[1]; // Re-add the delimiter for display
                }
                  return (
                    <div key={idx} className="relative bg-gray-100 text-xs p-2 rounded mb-2 w-full min-h-[8vh]">
                      <p className="whitespace-pre-wrap pb-4">{commentText}</p>
                      <div className="absolute bottom-1 right-2 text-[10px] text-gray-500 italic py-1">
                        {commentMeta}
                      </div>
                    </div>
                  );
                })}
            </div>
            {/* Add Comment Section */}
            {showCommentInput ? (
              <div className="mt-2 ">
                <textarea
                  className="w-full border border-gray-300 rounded p-2 text-sm"
                  rows="3"
                  placeholder="Type your comment here..."
                  value={newCommentText}
                  onChange={(e) => setNewCommentText(e.target.value)}
                />
                <div className="flex gap-2 mt-1">
                  <button
                    onClick={handleAddComment}
                    className="text-gray-600 hover:bg-white text-xs mt-1 bg-gray-200 p-1 font-semibold shadow-xl rounded-sm"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => {
                      setShowCommentInput(false);
                      setNewCommentText('');
                    }}
                    className="text-gray-500 hover:text-red-500 text-xs"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <div className='text-right'>
                  <button
                  type="button"
                  onClick={() => setShowCommentInput(true)}
                  className="text-gray-600 hover:bg-white text-xs mt-1 bg-gray-200 p-1 font-semibold shadow-xl rounded-sm"
                >
                  + Add Comment
                </button>
                </div>
              )}
        </div>
      </div>
    </div>
  )
}

export default TaskInfo